<template>
  <div>
    <div class="w-100 d-inline-block bg-introduction">
      <div class="container autoContent">
        <div class="row our-story-section align-items-center position-relative">
          <!-- Left: media cards -->
          <div
            class="col-xl-6 col-lg-6 col-md-6 col-12 order-1 order-md-1 mt-4 mt-md-0"
          >
            <div class="story-media position-relative">
              <!-- Main large image -->
              <div class="story-main-image rounded-4 overflow-hidden shadow-sm">
                <img
                  class="w-100 h-100 object-fit-cover"
                  v-lazy="require('@/assets/images/grooming-services-mobile-grooming-service.png')"
                  alt="grooming services, mobile grooming service"
                >
              </div>

              <!-- Top Left: Rating card -->
              <div class="story-card story-card-rating shadow-sm text-center">
                  <div class="d-flex justify-content-center pt-2 pb-1">
                      <img v-lazy="require('@/assets/images/customer-image.svg')" class="rating-avatar rounded-circle border border-1 border-white" alt="user">
                      <img v-lazy="require('@/assets/images/amazing-pet-grooming-pet-care-services.png')" class="rating-avatar rounded-circle border border-1 border-white ms-n1" alt="user">
                      <img v-lazy="require('@/assets/images/about-image-cat-2.webp')" class="rating-avatar rounded-circle border border-1 border-white ms-n1" alt="user">
                      <img v-lazy="require('@/assets/images/about-image-cat-2.webp')" class="rating-avatar rounded-circle border border-1 border-white ms-n1" alt="user">
                  </div>
                  <div class="rating-stars mb-1">
                      <i class="fa fa-star text-warning text-size-12 me-1" v-for="i in 5" :key="i"></i>
                  </div>
                  <p class="mb-0 text-size-10 family-inter-semi text-black">4.8 (100+) Reviews</p>
              </div>

              <!-- Middle Right: Video card -->
              <div class="story-card story-card-video shadow-sm p-0 overflow-hidden text-center bg-white">
                 <div class="video-thumbnail position-relative" style="height: 80px;">
                    <img
                        class="w-100 h-100 object-fit-cover"
                        v-lazy="require('@/assets/images/about-video-image.png')"
                        alt="grooming video"
                    >
                    <div class="position-absolute top-50 start-50 translate-middle">
                        <i class="fa fa-play-circle text-white text-size-28"></i>
                    </div>
                 </div>
                 <div class="p-2">
                    <p class="mb-0 text-size-9 family-inter-light text-black lh-sm">
                        Click on this video to check how work with our clients
                    </p>
                 </div>
              </div>

              <!-- Bottom Right: Accent card -->
              <div class="story-card story-card-small shadow-sm overflow-hidden p-0">
                 <img
                  class="w-100 h-100 object-fit-cover"
                  v-lazy="require('@/assets/images/grooming-services-mobile-grooming-corner.png')"
                  alt="grooming services"
                >
              </div>
            </div>
          </div>

          <!-- Right: content -->
          <div
            class="col-xl-6 col-lg-6 col-md-6 col-12 order-2 order-md-2 mt-4 mt-md-0"
          >
            <div class="w-100 d-inline-block">
              <p
                class="fw-bold txt-orange text-uppercase text-size-14 mb-1 family-filson-bold"
              >
                About Us
              </p>
              <h2
                class="text-black fw-bold family-filson-bold mb-3 text-size-36 text-full-28"
              >
                Our Story
              </h2>
              
              <p class="mb-4 text-size-15 text-black family-inter-light text-full-13 lh-lg">
                {{ storyContent }}
              </p>

              <div class="d-flex align-items-start mb-4">
                <div class="me-2 mt-1 py-1">
                   <div class="bg-black rounded-circle" style="width: 6px; height: 6px;"></div>
                </div>
                <p class="mb-0 text-size-14 family-inter-semi text-black fw-bold">
                  Instantly book a professional groomer at a time that works best for you.
                </p>
              </div>

              <div class="row g-3 align-items-center">
                <div class="col-sm-auto col-6">
                  <router-link
                    class="text-white text-size-12 d-inline-flex align-items-center justify-content-center book-btn bg-orange inter-semi-bold text-uppercase px-4 py-2 rounded-2 text-full-11"
                    to="/booking/"
                  >
                    Book Online
                  </router-link>
                </div>

                <div class="col-sm-auto col-6">
                  <button
                    type="button"
                    class="btn btn-link text-uppercase text-size-12 text-full-11 inter-semi-bold text-decoration-none px-2 py-2 d-inline-flex align-items-center txt-orange fw-bold"
                    @click="openCall"
                  >
                    <img
                      class="me-2 h-20"
                      v-lazy="require('@/assets/images/call-calling.svg')"
                      alt="schedule a call"
                      style="filter: invert(53%) sepia(81%) saturate(2250%) hue-rotate(345deg) brightness(101%) contrast(101%);"
                    >
                    Schedule a Call
                  </button>
                </div>
              </div>

              <div class="d-flex align-items-center mt-4">
                <div class="story-avatars me-3">
                  <img v-lazy="require('@/assets/images/customer-image.svg')" class="story-avatar rounded-circle border border-2 border-white" alt="user">
                  <img v-lazy="require('@/assets/images/amazing-pet-grooming-pet-care-services.png')" class="story-avatar rounded-circle border border-2 border-white ms-n1" alt="user">
                  <img v-lazy="require('@/assets/images/about-image-cat-2.webp')" class="story-avatar rounded-circle border border-2 border-white ms-n1" alt="user">
                  <div class="story-avatar rounded-circle bg-orange text-white d-flex align-items-center justify-content-center border border-2 border-white ms-n1 text-size-10 fw-bold">10K+</div>
                </div>
                <p class="mb-0 text-size-12 family-inter-light">
                  <span class="fw-bold txt-blue">10K+</span> Users rated us – see the quality we offer
                </p>
              </div>
            </div>
          </div>
          
          <!-- Pets strip on far right -->
          <div class="position-absolute end-0 bottom-0 d-none d-lg-block z-1" style="width: auto; margin-right: -150px; margin-bottom: -10px;">
            <img
              class="story-pets-strip"
              v-lazy="require('@/assets/images/cat-dog-birds-icon-image.webp')"
              alt="pet grooming"
              style="max-width: 250px;"
            >
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
  import {
    readSelectedWebsiteContactRaw,
    normalizeContactForTel,
  } from '@/utils/websiteContact';

  export default {
    name: "petsintroductionComponent.vue",
    data() {
      return {
        storyContent:
          'Are you a pet lover and looking for the best pet groomer in Dubai for your buddy? We take pride in offering a comprehensive range of mobile pet grooming services, designed to cater unique needs and preferences of every furry companion. We have been grooming for many years now and we love every part of our job! We provide a very warm and friendly environment for your pets. Our professional team made sure your pet always gets the highest level of care, because we treat all pets as if they were our own!',
      };
    },
    methods: {
      async fetchHomePage() {
        try {
          const res = await this.$axios.post('/get-home-page', {
            website_name: this.activeWebsiteName,
          });
          const page = res?.data?.home_page;
          if (!page) return;
          this.storyContent = page.story_content || this.storyContent;
          const name = (this.$countryName || '').toString().trim();
          if (name) this.storyContent = String(this.storyContent).replace(/dubai/gi, name);
        } catch (e) {
          console.error('fetchHomePage', e);
        }
      },
       async openCall() {
        // console.log("Call link clicked");
    
        // First, call the API to store the click data
        await this.callClick('call');
    
        // Then open the phone app
        const phoneNumber = normalizeContactForTel(readSelectedWebsiteContactRaw());
        const telUrl = `tel:${phoneNumber}`;
        window.open(telUrl, "_blank");
      },  
      async callClick(method) {
       try {
        const payload = {
          website_name: this.activeWebsiteName,
          type: method,
          ip: 'call',
        
        };
        const response = await this.$axios.post('/click-count', payload);
        console.log('Response:', response.data);
        
      } catch (err) {
        console.error('Error during call click:', err);
      }
    },
            openWhatsApp() {
    window.dispatchEvent(new CustomEvent('open-whatsapp-chat'));
  },
    },
    mounted() {
      const name = (this.$countryName || '').toString().trim();
      if (name) this.storyContent = String(this.storyContent).replace(/dubai/gi, name);
      this.fetchHomePage();
    },
    watch: {
      activeWebsiteName() {
        this.fetchHomePage();
      },
    },
  };
</script>

<style scoped>
.story-media {
  max-width: 480px;
  margin: 0 auto;
}
.text-blue{
  color: #00B7AF !important;
}
.story-main-image {
  height: 430px;
  width: 90%;
  border-radius: 15px !important;
}

.story-card {
  position: absolute;
  background-color: #ffffff;
  border-radius: 12px;
  z-index: 2;
}

.story-card-rating {
  top: -25px;
  left: -20px;
  width: 130px;
  padding: 5px 4px;
  border: 3px solid #F2F2F2;
}

.rating-avatar {
  width: 24px;
  height: 24px;
  object-fit: cover;
}

.story-card-video {
  top: -5px;
  right: 30px;
  width: 140px;
  min-height: 125px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  border: 3px solid #F2F2F2;
}

.story-card-small {
  bottom: -5px;
  right: 25px;
  width: 200px;
  height: 185px;
  border-radius: 20px;
}

.bg-orange {
  background-color: #fd7e14 !important;
}

.txt-orange {
  color: #fd7e14 !important;
}

.ms-n1 {
  margin-left: -8px !important;
}

.story-avatar {
  width: 34px;
  height: 34px;
  object-fit: cover;
}

.story-avatars {
  display: flex;
  align-items: center;
}

.story-pets-strip {
  transform: translateY(10px);
}

.text-size-9 { font-size: 9px; }
.text-size-10 { font-size: 10px; }
.text-size-28 { font-size: 28px; }

@media (max-width: 767.98px) {
  .story-media {
    max-width: 100%;
    margin-bottom: 30px;
  }
  .story-main-image {
    height: 300px;
    width: 90%;
  }

  .story-card-rating {
    top: 5px;
    left: -10px;
    width: 110px;
  }

  .story-card-video {
    top: 20px;
    right: 0;
    width: 130px;
  }

  .story-card-small {
    bottom: -5px;
    right: 25px;
    width: 200px;
    height: 185px;
  }
}
</style>
